import GeneratePPAP from "./GeneratePPAP";

export default GeneratePPAP;
